import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ESelectionType } from "../shared/sharedEnums";
import { RootState } from "../core/store";

export interface PageContextState {
    feature: string | null; // "kpis", "value", etc
    selectionType: ESelectionType;
    selectionId?: string; // IMO, portfolio id, sector id, etc
    tab?: string;
    subtab?: string;
}

const initialState: PageContextState = {
    feature: null,
    selectionType: ESelectionType.None,
    tab: undefined,
    subtab: undefined,
};

const pageContextSlice = createSlice({
    name: "pageContext",
    initialState,
    reducers: {
        setFeature(state, action: PayloadAction<string | null>) {
            state.feature = action.payload;
        },
        setSelection(
            state,
            action: PayloadAction<{ type: ESelectionType; id?: string }>
        ) {
            state.selectionType = action.payload.type;
            state.selectionId = action.payload.id;
        },
        setTab(state, action: PayloadAction<string | undefined>) {
            state.tab = action.payload;
        },
        setSubtab(state, action: PayloadAction<string | undefined>) {
            state.subtab = action.payload;
        },
        resetContext() {
            return initialState;
        }
    },
});

export const { setFeature, setSelection, setTab, setSubtab, resetContext } = pageContextSlice.actions;

export const selectFeature = (state: RootState) => state.pageContextSlice.feature;
export const selectSelectionType = (state: RootState) => state.pageContextSlice.selectionType;
export const selectSelectionId = (state: RootState) => state.pageContextSlice.selectionId;
export const selectTab = (state: RootState) => state.pageContextSlice.tab;
export const selectSubtab = (state: RootState) => state.pageContextSlice.subtab;

export default pageContextSlice.reducer;
